import React from 'react';
import './OrderConfirmModalFooter.css';

export default function OrderConfirmModalFooter({ children }) {
  return <div className="order-confirm-modal-footer">{children}</div>;
}
